import moment from 'moment';

import type { NRecords } from '@app/types';

export const groupRecords = (
  records: NRecords.ModelClientRecord[]
): NRecords.VisitHistoryRecords => {
  const groupedRecords = records.reduce<NRecords.VisitHistoryRecords>(
    (groups, record) => {
      const date = moment(record.TimeS).format('YYYY-MM-DD');
      const existingGroup = groups[date] || [];

      groups[date] = [...existingGroup, record];

      return groups;
    },
    {}
  );

  return groupedRecords;
};
